import request from '../../helpers/request';

import { QueryKeys } from '../../config/constants/react-query';
import { BASE_URL } from '../../config/constants/contants';

import { TGetNewsResponse } from '../../types/TGetNewsResponse';
import { TSupportedLanguages } from '../../types/TSupportedLanguages';

const useGetNews = (
  offset: number,
  language: TSupportedLanguages,
  page: number,
  isHome: boolean,
) => {
  const { data, isLoading, error, refetch } = request<TGetNewsResponse>(
    `${BASE_URL}/api/v1/news?offset=${offset}&language=${language}&page=${page}&isHome=${isHome}`,
    QueryKeys.NewsPosts,
    true,
    page,
  );

  return { data, isLoading, error, refetch };
};

export default useGetNews;
